<article class="cart-item">
  <img
    class="cart-item-thumbnail"
    alt="produit"
    [src]="imageSource"
    (error)="setImageLoadError($event)"
    width="40"
    height="40" />

  <div class="cart-item-details">
    <span class="cart-item-name">{{ line.label }}</span>
    <span class="cart-item-price">{{ line.price | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</span>
  </div>

  <ng-casto-button
    class="secondary borderless cart-item-remove"
    [faIcon]="faTrash"
    [disabled]="tunnelCartService.isLocked()"
    (click)="changeQuantity(0)"></ng-casto-button>

  <div class="cart-item-actions">
    <div class="cart-item-quantity">
      <ng-casto-button
        class="primary"
        [faIcon]="faMinus"
        [disabled]="tunnelCartService.isLocked()"
        (click)="changeQuantity(line.quantity - 1)"></ng-casto-button>
      <span class="cart-item-quantity-value">{{ line.quantity }}</span>
      <ng-casto-button
        class="primary"
        [faIcon]="faPlus"
        [disabled]="tunnelCartService.isLocked()"
        (click)="changeQuantity(line.quantity + 1)"></ng-casto-button>
    </div>

    <span class="cart-item-total">{{ lineTotal | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</span>
  </div>
</article>
